import { useQuery } from "@apollo/client";

import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { GET_SOURCES } from "../../../queries/archiveQrys/InventoryReportQueries";
import {
  waterSystemStatus,
  activityType,
  sourceType,
  waterType
} from "../../../utilities/constants/WaterSystemConstants";
import { convertTimeStampToDate } from "../../../utilities/commonFunctions/timeConversionFunctions";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const SourcesTablePublic = ({ systemId }) => {
  const columns = [
    {
      Header: "ID",
      accessor: "sourceId",

      width: 75
    },
    {
      Header: "Source Name",
      accessor: "sourceName",
      width: 250
    },
    {
      Header: "OP Date",
      accessor: (d) => {
        return d.opDate !== true ? convertTimeStampToDate(d.opDate) : "";
      },
      width: 75
    },
    {
      Header: "Status",
      accessor: (d) => {
        return d.status ? waterSystemStatus[d.status] : "";
      },
      width: 80
    },
    {
      Header: "Reason",
      accessor: (d) => {
        return d.statusReason ? activityType[d.statusReason] : "";
      },
      width: 250
    },
    {
      Header: "Source Type",
      accessor: (d) => {
        return d.sourceType ? sourceType[d.sourceType] : "";
      },
      width: 100
    },
    {
      Header: "Water Type",
      accessor: (d) => {
        return d.waterType ? waterType[d.waterType] : "";
      }
    },
    {
      Header: "Period of Op",
      accessor: (d) => {
        return d.status === "A" && d.startMonth && d.startDay
          ? d.startMonth + "/" + d.startDay + " - " + d.endMonth + "/" + d.endDay
          : "";
      }
    }
  ];

  const { loading, error, data } = useQuery(GET_SOURCES, { variables: { systemId } });

  let totalSources = 0;

  if (loading) {
    return <SkeletonLoader width='100%' />;
  } else if (error) {
    return <ErrorHandler error={error} />;
  } else {
    let sourcesArray = data.getSourcesBySystemId;
    totalSources = sourcesArray.length;
  }

  return (
    <>
      <DtsReactTable
        data={data.getSourcesBySystemId}
        columns={columns}
        headerColor='ddw'
        cypressid='sourcesPublicTbl'
      />
      <h5>Total Sources: {totalSources}</h5>
    </>
  );
};

export default SourcesTablePublic;
